module.exports = __webpack_public_path__ + "img/Boxes.7c2b10ac.svg";